import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-decline-comments-dialog',
  templateUrl: './decline-comments-dialog.component.html',
  styleUrls: ['./suspension-doa.component.scss']
})
export class DeclineCommentsDialogComponent implements OnInit {
  commentsForm: FormGroup;
  isSubmitted: boolean = false;

  constructor(public dialogRef: MatDialogRef<DeclineCommentsDialogComponent>) { }

  ngOnInit(): void {
    this.commentsForm = new FormGroup({
      comments: new FormControl('', [Validators.required])
    });
  }

  onSubmit(): void {
    if (this.commentsForm.invalid) {
      this.commentsForm.markAllAsTouched();
      return;
    }
    this.isSubmitted = true;
    this.dialogRef.close(this.commentsForm.get('comments').value);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}

